module.exports = __webpack_public_path__ + "img/banner_01.ee2a0fa2.png";